import { put, takeLatest } from "redux-saga/effects";
import { keHoachThucTapDoanhNghiepApi } from "../../../api/xet-thuc-tap/keHoachThucTapDoanhNghiepApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eKeHoachThucThucTapDoanhNghiepActionIds, IKeHoachThucTapDoanhNghiepActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapDoanhNghiepActions";
import { rootActions } from "../../actions/rootActions";
import { IKeHoachThucTapDoanhNghiep } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapDoanhNghiep";


export function* keHoachThucTapDoanhNghiepSaga(): any {
   yield takeLatest(eKeHoachThucThucTapDoanhNghiepActionIds.LOAD_BY_DOT_THUC_TAP_START, loadByDotThucTapWorker);
}

function* loadByDotThucTapWorker(action: IKeHoachThucTapDoanhNghiepActionTypes): any {
    const id_dot_thuc_tap = action.payload as number;
  const response: IBaseResponse = yield keHoachThucTapDoanhNghiepApi.SelectByDotThucTap(id_dot_thuc_tap);
  if (response.is_success)
  {
    yield put(rootActions.xetThucTap.keHoachThucTapDoanhNghiep.LOAD_BY_DOT_THUC_TAP_SUCCESS(toLowerCaseDeep(response.data)));
  } else {
    yield put(rootActions.xetThucTap.keHoachThucTapDoanhNghiep.LOAD_BY_DOT_THUC_TAP_ERROR(response.message || "Lỗi không xác định"));
  }
}

function* saveWorker(action: IKeHoachThucTapDoanhNghiepActionTypes): any {
    const data = action.payload as IKeHoachThucTapDoanhNghiep;
    let response: IBaseResponse;
    if (data.id_gan_dot_doanh_nghiep > 0) {
        response = yield keHoachThucTapDoanhNghiepApi.Update(data.id_gan_dot_doanh_nghiep, data);
    } else {
        response = yield keHoachThucTapDoanhNghiepApi.Insert(data);
    }
    if (response.is_success) {
        yield put(rootActions.xetThucTap.keHoachThucTapDoanhNghiep.SAVE_SUCCESS(undefined));
    } else {
        yield put(rootActions.xetThucTap.keHoachThucTapDoanhNghiep.SAVE_ERROR(response.message || "Lỗi không xác định"));
    }
}